<script>
export default {
    name: "HeartIcon"
}
</script>
<template>
    <svg aria-hidden="true" width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.4375 14.5C0.875 12.9375 0 10.75 0 8.5C0 3.8125 3.75 0 8.4375 0C10.6875 0 12.875 0.9375 14.4375 2.5L16 4L17.5 2.5C19.0625 0.9375 21.25 0 23.5 0C28.1875 0 32 3.8125 32 8.5C32 10.75 31.0625 12.9375 29.5 14.5L28 16L16 28L4 16L2.4375 14.5Z" fill="#78B1BB"/>
    </svg>
</template>
